import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@weezevent/nacre';
import { PreviewEmpty } from '../../../../../../sessions/components/previewEmpty';
import css from '../manual-modal.module.css';

function EmptyCart() {
    const { t } = useTranslation();
    return <PreviewEmpty className={css['modal-summary-item']} title={t('ticket.seats.modal')} icon={<Icon className={css['preview-icon']} name="cart" size="huge" />} />;
}

export default EmptyCart;
